import { CircularProgress, Paper, Typography } from '@mui/material';
import { useExperiences } from 'core/contexts/experienceV2';
import { useAuth } from 'core/contexts/auth';
import { useTranslation } from 'react-i18next';

const UploadStatus = () => {
    const { t: translate } = useTranslation();
    const { userInfo } = useAuth();
    const { isUploading } = useExperiences();

    if (!userInfo?.id || !isUploading) return null;

    return (
        <Paper
            elevation={5}
            sx={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                padding: 2,
                width: 250,
                zIndex: 2000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
            }}
        >
            <Typography>{translate('upload_status')}</Typography>
            <CircularProgress />
        </Paper>
    );
};

export default UploadStatus;
